import type { ThemeColors } from "@generalapplications/ui";

// This site's colour-scheme settings; the library keeps and applies the choice.
export const themeStorageKey = "ga-theme";

export const themeColors: ThemeColors = {
  light: "#ffffff",
  dark: "#1c1a17",
};
